import { useCallback, useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { toast } from "sonner";
import { providerService } from "@/services/providerService";
import { errorMessage } from "@/services/apiClient";
import { EngineMarketRow } from "@/components/engine/EngineMarketRow";

export const PriceEngineCard = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    try {
      setStatus(await providerService.engineStatus());
    } catch {
      setStatus(null);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const refresh = async (market) => {
    setBusy(market);
    try {
      const r = await providerService.engineRefresh(market);
      if (r.success) toast.success(`${market}: ${r.stored} ativos atualizados via ${r.provider}`);
      else toast.error(`${market}: ${r.message}`);
      load();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy("");
    }
  };

  const markets = Object.entries(status?.markets || {});

  return (
    <section data-testid="price-engine-card" className="rounded-md border border-[#22252F] bg-[#12141A] p-6 sm:p-8">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Gauge className="h-4 w-4 text-[#60A5FA]" />
          <h2 className="font-heading text-lg font-light tracking-tight text-white md:text-lg">Price Engine</h2>
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#94A3B8]"
                data-testid="engine-cached-symbols">
            {status?.cached_symbols ?? 0} símbolos em cache
          </span>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead className="text-[11px] uppercase tracking-[0.2em] text-[#94A3B8]">
            <tr>
              <th className="py-3 pr-6">Mercado</th>
              <th className="py-3 pr-6">Estado</th>
              <th className="py-3 pr-6">Provedores</th>
              <th className="py-3 pr-8 text-right">Intervalo</th>
              <th className="py-3 pr-6">Última atualização</th>
              <th className="py-3 text-right">Ação</th>
            </tr>
          </thead>
          <tbody data-testid="engine-markets-body">
            {markets.map(([market, m]) => (
              <EngineMarketRow key={market} market={market} data={m}
                               busy={busy === market} onRefresh={refresh} />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
